import { useState, useEffect } from 'react';
import axios from 'axios';

import { useMsal, useAccount } from "@azure/msal-react";
import { silentRequest } from "../../../authConfig";

import { useHistory, useLocation } from 'react-router-dom';

import {
  Stack,
  Icon,
  PrimaryButton,
  DefaultButton,
  Spinner,
  getTheme,
  MessageBar,
  MessageBarType,
  Separator,
  Toggle
} from '@fluentui/react';

// const API_URL = process.env.REACT_APP_API_URL;
const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL;

const theme = getTheme();

// Processing dialog style
const spinnerStyles = {
  circle: {
    height: 24,
    width: 24,
    borderWidth: 4,
    marginTop: 25
  }
}

const spinnerStylesLoading = {
  circle: {
    height: 56,
    width: 56,
    borderWidth: 4,
  },
};

const cardStyle = {
  paddingLeft: 30,
  paddingRight: 30,
  paddingTop: 20,
  paddingBottom: 30,
  background: '#ffffff',
  marginLeft: '0',
  marginTop: '10px',
  boxShadow: theme.effects.elevation4,
};

const homeStyles = {
  border: 0,
  margin: 0,
  width: '100%',
  background: '#FAF9F8',
  position: 'relative',
};

const SettingsPermissions = () => {

  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const history = useHistory();
  const location = useLocation();

  const [data] = useState(location.state);

  const [oid, setOid] = useState('');
  const [companyId, setCompanyId] = useState('');

  const [getNewData, setGetNewData] = useState(false);
  const [accountData, setAccountData] = useState({});

  // const [credits, setCredits] = useState(0);
  // const [topupAmount, setTopupAmount] = useState(0);
  // const [totalAmount, setTotalAmount] = useState(0);
  // const [lastTopup, setLastTopup] = useState(0);
  // const [lastTopupTime, setLastTopupTime] = useState('');

  // const [isLoading, setIsLoading] = useState(true);
  const [isLoadingGetNewData, setIsLoadingGetNewData] = useState(true);
  const [isLoadingSubmitEnabled, setIsLoadingSubmitEnabled] = useState(false);

  const [permissions, setPermissions] = useState({
        "folders": {
            "sales": true,
            "accountReceivable": true,
            "purchasing": true,
            "withholdingTax": true
        },
        "organization": {
            "company": true,
            "contacts": true,
            "taxInvoiceRequesters": true,
            "paymentMethods": true
        },
        "externalDataErp": {
            "msDynamics365Bc": true,
            "msDynamics365Fo": true,
            "msDynamics365Sales": true,
            "sapBusinessOne": true
        },
        "externalData": {
            "lazada": true,
            "lineShopping": true,
            "paypal": true,
            "peakAccount": true,
            "quickbooks": true,
            "shipnity": true,
            "shopee": true,
            "tiktokShop": true,
            "trCloud": true,
            "wooCommerce": true,
            "xero": true,
            "zoho": true,
            "importExcel": true
        },
        "products": {
            "productList": true
        },
        "submitEtax": {
            "submitXml": true
        },
        "reports": {
            "salesReport": true,
            "outputTaxReport": true,
            "inputTaxReport": true,
            "xmlDeliveryReport": true,
            "historyEmailLog": true,
            "historySmsLog": true
        },
        "exportRdPrep": {
            "pp30": true,
            "pnd2": true,
            "pnd3": true,
            "pnd53": true
        },
        "billing": {
            "packageDetail": true,
            "paymentHistory": true,
            "paymentSettings": true
        },
        "settings": {
            "certificates": true,
            "xmlDelivery": true,
            "templates": true,
            "email": true,
            "requestTaxInvoiceForm": true,
            "apiKey": true,
            "userManual": true
        }
    })
    

  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (companyId) {
      getPackage()
    }
  }, [companyId]);
  
  useEffect(() => {

    console.log('useEffect accountData call!: ');

    console.log('accountData', accountData);

  }, [accountData]);

  useEffect(() => {
    console.log('useEffect getNewData call!');

    console.log('oid: ', oid);
    console.log('companyId: ', companyId);

    if (getNewData) {

      if (oid && companyId) {
        //console.log('useEffect data call! not undefied.');

        console.log('data: ', data);

        accountsOidList(oid);

      }

      // setGetNewData(false);
      // setIsLoadingGetNewData(false);

    }

  }, [getNewData]);

  useEffect(() => {
    console.log('useEffect data call!: ', data);


    if (data !== undefined) {
      //console.log('useEffect data call! not undefied.');

      console.log('data: ', data);
      setCompanyId(data.companyId);
      setOid(data.oid)

      accountsOidList(data.oid);

      // setGetNewData(true);
      // setIsLoadingGetNewData(true);

    } else {
      history.push({ pathname: '/accounts/prepaid', state: {} });
    }


  }, [data]);

  async function accountsOidList(oid) {

    console.log('useEffect call!');

    // let accountsOidListEndpoint = 'http://localhost:7071/api/AccountsOidList?oidList=' + oid;
    let accountsOidListEndpoint = ADMIN_API_URL + '/accounts?oidList=' + oid;
    console.log("accountsOidListEndpoint: ", accountsOidListEndpoint);

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        // Do something with the tokenResponse
        console.log("Token response: ", tokenResponse);

        // Retrive companies details list
        const [responseAccountsOidList] = await Promise.all([
          axios
            .get(accountsOidListEndpoint, {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
              },
            })
            .catch((error) => console.log(error)),
        ]);
        console.log("responseAccountsOidList: ", responseAccountsOidList.data);


        if (responseAccountsOidList.data.length > 0) {
          setAccountData(responseAccountsOidList.data[0]);
        }

      })
      .catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);
      });

  }

  async function getPackage() {
    instance
    .acquireTokenSilent({ ...silentRequest, account: account })
    .then(async (tokenResponse) => {
      const responseCurrentPackage = await axios.get(`${ADMIN_API_URL}/packages/main?companyId=${companyId}`, {
      // const responseCurrentPackage = await axios.get(`http://localhost:7071/api/packages/main/${'c8d1bf6b-bf74-4608-ae46-34a282990e13'}`, {
                                                      headers: {
                                                        Authorization: 'Bearer ' + tokenResponse.accessToken,
                                                        'cid': companyId,
                                                        // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
                                                      },
                                                    })


      console.log("responseCurrentPackage", responseCurrentPackage);

      if (responseCurrentPackage?.data) {
        if (responseCurrentPackage.data.permissions) {
          setPermissions(responseCurrentPackage.data.permissions)
        }
      }

      setIsLoadingGetNewData(false)


    
    }).catch((error) => {
      //Acquire token silent failure, and send an interactive request
      console.log("getPackageAndAccountDetail error", error);
      // instance.acquireTokenRedirect(silentRequest);
    });
  }

  const handleSubmitUpdatePermissions = (e) => {

    e.preventDefault();

    if (permissions) {
      setIsLoadingSubmitEnabled(true);
      setIsLoadingGetNewData(true);
  
      instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then((tokenResponse) => {
          axios
            .patch(
              `${ADMIN_API_URL}/packages/main`,
              // `http://localhost:7071/api/packages/main`,
              {
                replace: '/permissions',
                value: permissions
              },
              {
                headers: {
                  Authorization: 'Bearer ' + tokenResponse.accessToken,
                  'Content-Type': 'application/json',
                  'cid': companyId,
                  // 'cid': 'c8d1bf6b-bf74-4608-ae46-34a282990e13',
                },
              }
            )
            .then(
              (response) => {
                //console.log(response.data.id);
                console.log(response);
                // setIsLoadingSubmitPackageStatus(false);
                // setIsLoadingGetNewData(false);
                setIsLoadingSubmitEnabled(false);

                getPackage()
  
                setGetNewData(true);
  
                setShowSuccess(true);
                // window.scrollTo(0, 0);
  
              },
              (error) => {
  
                console.log(error);
                setIsLoadingSubmitEnabled(false);
                // setIsLoadingGetNewData(false);
  
                setGetNewData(true);
  
                setShowError(true);
                // window.scrollTo(0, 0);
  
              }
            );
  
        })
        .catch((error) => {
  
          //Acquire token silent failure, and send an interactive request
          console.log(error);
          instance.acquireTokenRedirect(silentRequest);
  
        });
    }
  }

  return (
    <>
      <div style={homeStyles}>

        {showSuccess && (
          <MessageBar
            messageBarType={MessageBarType.success}
            isMultiline={false}
            onDismiss={() => setShowSuccess(false)}
            dismissButtonAriaLabel="Close"
            style={{
              fontSize: 14,
            }}
          >
            บันทึกสำเร็จ!
          </MessageBar>
        )}
        {showError && (
          <MessageBar
            messageBarType={MessageBarType.error}
            isMultiline={false}
            onDismiss={() => setShowError(false)}
            dismissButtonAriaLabel="Close"
            style={{
              fontSize: 14,
            }}

          >
            บันทึกไม่สำเร็จ!
          </MessageBar>
        )}


        <Stack horizontal horizontalAlign="center">
          <Stack
            vertical
            style={{
              width: '80%',
              maxWidth: '500px',
            }}>
            <h1 style={{ marginLeft: '0px', marginTop: '27px' }} ><Icon iconName="CityNext2" style={{ color: '#106ebe' }} /> ตั้งค่า Permissions</h1>
            {/* <h3 style={{ marginTop: '0px', marginBottom: '10px' }} >{data.companyName}</h3> */}
            {/* <br/> */}
            companyId: {data.companyId}
            <br />
            ชื่อบริษัท: {data.companyName}
            <br />
            อีเมล: {data.email}
            <br />
            <br />

            oid: {data.oid}
            <br />
            อีเมลเข้าสู่ระบบ: {accountData.profiles?.email}
            <br />
            ชื่อ: {accountData.profiles?.firstName} {accountData.profiles?.lastName}
            <br />
            เบอร์โทร: {accountData.profiles?.mobile}
            <br />
            <br />
            {/*                 เครดิตเอกสาร: {credits}
                <br/>
                เติมล่าสุด: {lastTopup}
                <br/>
                เวลาเติมล่าสุด: {lastTopupTime}                                
                <br/>
                <br/>
 */}
            {!isLoadingGetNewData && (
              <div style={cardStyle}>
                <Stack >
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>

                    <DefaultButton
                      iconProps={{ iconName: "Refresh" }}
                      style={{ marginTop: "5px", marginBottom: "5px" }}
                      disabled={isLoadingGetNewData}
                      onClick={() => {
                        setGetNewData(true);
                        setIsLoadingGetNewData(true);
                      }}
                      text="รีเฟรช" />

                  </Stack>

                  <Separator />
                  <Stack style={{ marginBottom: "10px" }}>
                    <Stack>
                      <strong>แฟ้มเอกสาร</strong>
                    </Stack>
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="รายรับ:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.folders.sales}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.folders.sales = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="ลูกหนี้การค้า:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.folders.accountReceivable}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.folders.accountReceivable = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="รายจ่าย:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.folders.purchasing}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.folders.purchasing = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="หัก ณ ที่จ่าย (50 ทวิ):"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.folders.withholdingTax}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.folders.withholdingTax = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Separator />
                  <Stack style={{ marginBottom: "10px" }}>
                    <Stack>
                      <strong>ข้อมูลภายใน</strong>
                    </Stack>
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="บริษัท:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.organization.company}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.organization.company = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="ผู้ติดต่อ:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.organization.contacts}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.organization.contacts = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="ผู้ขอใบกำกับภาษี:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.organization.taxInvoiceRequesters}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.organization.taxInvoiceRequesters = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="ช่องทางการชำระเงิน:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.organization.paymentMethods}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.organization.paymentMethods = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Separator />
                  <Stack style={{ marginBottom: "10px" }}>
                    <Stack>
                      <strong>ข้อมูลภายนอก ERP</strong>
                    </Stack>
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="MS Dynamics 365 BC:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalDataErp.msDynamics365Bc}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalDataErp.msDynamics365Bc = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="MS Dynamics 365 FO:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalDataErp.msDynamics365Fo}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalDataErp.msDynamics365Fo = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="MS Dynamics 365 Sales:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalDataErp.msDynamics365Sales}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalDataErp.msDynamics365Sales = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="SAP Business One:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalDataErp.sapBusinessOne}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalDataErp.sapBusinessOne = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Separator />
                  <Stack style={{ marginBottom: "10px" }}>
                    <Stack>
                      <strong>ข้อมูลภายนอก อื่นๆ</strong>
                    </Stack>
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="Lazada:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalData.lazada}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalData.lazada = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="LINE SHOPPING:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalData.lineShopping}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalData.lineShopping = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="PayPal:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalData.paypal}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalData.paypal = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="PEAK Account:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalData.peakAccount}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalData.peakAccount = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="QuickBooks:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalData.quickbooks}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalData.quickbooks = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="Shipnity:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalData.shipnity}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalData.shipnity = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="Shopee:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalData.shopee}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalData.shopee = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="TikTok Shop:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalData.tiktokShop}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalData.tiktokShop = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="TRCloud:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalData.trCloud}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalData.trCloud = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="Woo Commerce:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalData.wooCommerce}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalData.wooCommerce = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="Xero:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalData.xero}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalData.xero = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="Zoho:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalData.zoho}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalData.zoho = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="ไฟล์ Excel:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.externalData.importExcel}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.externalData.importExcel = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Separator />
                  <Stack style={{ marginBottom: "10px" }}>
                    <Stack>
                      <strong>สินค้า</strong>
                    </Stack>
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="รายการสินค้า:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.products.productList}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.products.productList = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Separator />
                  <Stack style={{ marginBottom: "10px" }}>
                    <Stack>
                      <strong>นำส่งข้อมูล E-Tax</strong>
                    </Stack>
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="นำส่งไฟล์ XML:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.submitEtax.submitXml}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.submitEtax.submitXml = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Separator />
                  <Stack style={{ marginBottom: "10px" }}>
                    <Stack>
                      <strong>รายงาน</strong>
                    </Stack>
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="รายงานยอดขาย:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.reports.salesReport}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.reports.salesReport = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="รายงานภาษีขาย:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.reports.outputTaxReport}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.reports.outputTaxReport = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="รายงานภาษีซื้อ:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.reports.inputTaxReport}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.reports.inputTaxReport = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="รายงานการนำส่ง XML:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.reports.xmlDeliveryReport}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.reports.xmlDeliveryReport = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="รายงานการนำส่ง อีเมล:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.reports.historyEmailLog}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.reports.historyEmailLog = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="รายงานการนำส่ง SMS:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.reports.historySmsLog}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.reports.historySmsLog = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Separator />
                  <Stack style={{ marginBottom: "10px" }}>
                    <Stack>
                      <strong>ไฟล์ RDPrep</strong>
                    </Stack>
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="ภ.พ.30:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.exportRdPrep.pp30}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.exportRdPrep.pp30 = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="ภ.ง.ด.2:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.exportRdPrep.pnd2}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.exportRdPrep.pnd2 = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="ภ.ง.ด.3:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.exportRdPrep.pnd3}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.exportRdPrep.pnd3 = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="ภ.ง.ด.53:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.exportRdPrep.pnd53}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.exportRdPrep.pnd53 = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Separator />
                  <Stack style={{ marginBottom: "10px" }}>
                    <Stack>
                      <strong>การชำระเงิน</strong>
                    </Stack>
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="ข้อมูลแพ็กเกจ:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.billing.packageDetail}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.billing.packageDetail = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="ประวัติการชำระเงิน:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.billing.paymentHistory}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.billing.paymentHistory = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="ตั้งค่าการชำระเงิน:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.billing.paymentSettings}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.billing.paymentSettings = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Separator />
                  <Stack style={{ marginBottom: "10px" }}>
                    <Stack>
                      <strong>ตั้งค่า</strong>
                    </Stack>
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="ใบรับรองอิเล็กทรอนิกส์:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.settings.certificates}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.settings.certificates = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="การนำส่งไฟล์ XML:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.settings.xmlDelivery}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.settings.xmlDelivery = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="รูปแบบเอกสาร:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.settings.templates}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.settings.templates = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="อีเมลที่ใช้ส่งเอกสาร:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.settings.email}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.settings.email = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="แบบฟอร์มขอใบกำกับภาษี:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.settings.requestTaxInvoiceForm}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.settings.requestTaxInvoiceForm = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="การเชื่อมต่อ API:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.settings.apiKey}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.settings.apiKey = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: "30px" }}>
                    <Toggle 
                      label="คู่มือการใช้งาน:"
                      inlineLabel
                      onText="เปิด" 
                      offText="ปิด"
                      checked={permissions.settings.userManual}
                      onChange={(e, check) => {
                        setPermissions(prev => {
                          const newPermission = {...prev};
                          newPermission.settings.userManual = check;

                          return newPermission;
                        });
                      }} 
                    />
                  </Stack>
                  <Separator />
                  <Stack horizontal horizontalAlign="center" tokens={{ childrenGap: "30px" }}>
                    {!isLoadingSubmitEnabled &&
                      <PrimaryButton
                        style={{ marginTop: "28px" }}
                        onClick={handleSubmitUpdatePermissions}
                        text="บันทึก" />
                    }
                    {isLoadingSubmitEnabled &&
                      <Spinner /* size={SpinnerSize.large} label="กำลังดำเนินการ..." labelPosition="right"*/ styles={spinnerStyles} />

                    }
                  
                  </Stack>
                </Stack>
              </div>
            )}
            <br />
            <br />
            <br />

          </Stack>
        </Stack>


        {isLoadingGetNewData && (
          <Stack>
            <br />
            <br />
            <br />
            <Stack horizontal horizontalAlign="center">
              <div className="certificates-loading-center">
                <Spinner
                  label="กำลังโหลด..."
                  labelPosition="down"
                  styles={spinnerStylesLoading}
                />
              </div>
              <br />
            </Stack>
          </Stack>
        )}
      </div>
    </>
  );

}

export default SettingsPermissions;